"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createFormikFieldComponent = exports.FormikFieldComponent = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("./Input"));
var _excluded = ["form", "onChange", "onBlur", "field", "id", "forForm", "children"];
// Wrapper component is used to that app-platform can wrap this in a <Track>
var createFormikFieldComponent = exports.createFormikFieldComponent = function createFormikFieldComponent(Component) {
  var WrapperComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var FieldComp = function FieldComp(props) {
    var _props$form = props.form,
      form = _props$form === void 0 ? {} : _props$form,
      onChange = props.onChange,
      onBlur = props.onBlur,
      field = props.field,
      id = props.id,
      forForm = props.forForm,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    var name = field.name;

    // allow for custom onChange/onBlur for parsing and formatting of input
    var onElementBlur = onBlur ? function (e) {
      onBlur(e);
      // call both to ensure normal validation behavior still occurs on blur
      field.onBlur(e);
    } : field.onBlur;
    var onElementChanged = onChange || field.onChange;
    var touched = form.touched && (form.touched[name] || form.touched[id]);
    var error = form.errors && (form.errors[name] || form.errors[id]);
    var formValues = (0, _values["default"])(form) || {};
    var formFieldValues = {
      "for": forForm,
      values: formValues
    };
    return WrapperComponent ? /*#__PURE__*/_react["default"].createElement(WrapperComponent, {
      formFieldValues: formFieldValues
    }, /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      id: id
    }, otherProps, field, {
      onChange: onElementChanged,
      onBlur: onElementBlur,
      touched: touched,
      error: error,
      help: touched && error || otherProps.help,
      bsStyle: (touched && error ? 'error' : undefined) || otherProps.bsStyle
    }), children)) : /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      id: id
    }, otherProps, field, {
      onChange: onElementChanged,
      onBlur: onElementBlur,
      touched: touched,
      error: error,
      help: touched && error || otherProps.help,
      bsStyle: (touched && error ? 'error' : undefined) || otherProps.bsStyle
    }), children);
  };
  FieldComp.propTypes = {
    id: _propTypes["default"].string.isRequired,
    children: _propTypes["default"].node,
    form: _propTypes["default"].shape({
      touched: _propTypes["default"].objectOf(_propTypes["default"].bool),
      errors: _propTypes["default"].objectOf(_propTypes["default"].string),
      name: _propTypes["default"].string,
      handleChange: _propTypes["default"].func.isRequired,
      handleBlur: _propTypes["default"].func.isRequired,
      // eslint-disable-next-line react/forbid-prop-types
      values: _propTypes["default"].object
    }),
    forForm: _propTypes["default"].string,
    field: _propTypes["default"].shape({
      name: _propTypes["default"].string,
      onChange: _propTypes["default"].func,
      onBlur: _propTypes["default"].func
    }),
    onChange: _propTypes["default"].func,
    onBlur: _propTypes["default"].func
  };
  FieldComp.defaultProps = {
    forForm: 'formik-form',
    form: {},
    field: {},
    children: null,
    onChange: undefined,
    onBlur: undefined
  };
  return FieldComp;
};
var FormikFieldComponent = exports.FormikFieldComponent = createFormikFieldComponent(_Input["default"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/FormikFieldComponent.js
// module id = 2143
// module chunks = 25